import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  color: white;\n  font-weight: 600;\n  font-size: 16px;\n  text-transform: uppercase;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  background: var(--footer-input);\n  padding: 10px 15px;\n  color: var(--input-color);\n  width: 100%;\n  border: 1px solid rgba(4, 26, 38, 0.62);\n  box-shadow: 0px 3px 7px rgba(182, 182, 182, 0.44);\n  border-radius: 5px;\n  ::placeholder {\n    color: --var(place-holder);\n  }\n  &:focus {\n    box-shadow: initial;\n    outline: none;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  padding: 10px;\n  border-radius: 4px;\n  border: none;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  width: 200px;\n  margin-left: auto;\n  margin-right: auto;\n  animation: rotate 4s infinite linear;\n\n  @keyframes rotate {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  color: white;\n  text-transform: uppercase;\n  margin-top: 20px;\n  transition: 0.3s;\n  font-weight: bold;\n\n  &:hover {\n    color: #3580f1;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  margin-top: 20px;\n\n  svg:hover {\n    path {\n      fill: #fff;\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  color: var(--copy-right);\n  margin-top: 15px;\n  font-size: 18px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  color: var(--heading-color);\n  font-weight: bold;\n  margin-left: 5px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from "react";
import axios from "axios";
import { useTranslation } from "@pancakeswap/localization";
import styled from "styled-components";
import { ReactSVG } from "react-svg";
import { Flex } from "../Box";
// import { Link } from "../Link";
import Link from "next/link";
import { StyledFooter, StyledIconMobileContainer, StyledList, StyledListItem, StyledSocialLinks, StyledText } from "./styles";
import CoinFooter from "../../../../../public/images/footer-coin.png";
import SubmitBtn from "../../../../../public/images/arrow-img.svg";
import { baseURL } from "../../../../../constants";
var FooterHeading = styled.h3.withConfig({
    componentId: "sc-4f938a64-0"
})(_templateObject());
var EmailInput = styled.input.withConfig({
    componentId: "sc-4f938a64-1"
})(_templateObject1());
var SubmitButton = styled.button.withConfig({
    componentId: "sc-4f938a64-2"
})(_templateObject2());
var CannabisIcon = styled.img.withConfig({
    componentId: "sc-4f938a64-3"
})(_templateObject3());
var CustomListItem = styled(StyledListItem).withConfig({
    componentId: "sc-4f938a64-4"
})(_templateObject4());
var SocialLinks = styled(StyledSocialLinks).withConfig({
    componentId: "sc-4f938a64-5"
})(_templateObject5());
var Copyright = styled.p.withConfig({
    componentId: "sc-4f938a64-6"
})(_templateObject6());
var LogoText = styled.h2.withConfig({
    componentId: "sc-4f938a64-7"
})(_templateObject7());
var MenuItem = function(_param) {
    var items = _param.items, isDark = _param.isDark, toggleTheme = _param.toggleTheme, currentLang = _param.currentLang, langs = _param.langs, setLang = _param.setLang, cakePriceUsd = _param.cakePriceUsd, buyCakeLabel = _param.buyCakeLabel, props = _object_without_properties(_param, [
        "items",
        "isDark",
        "toggleTheme",
        "currentLang",
        "langs",
        "setLang",
        "cakePriceUsd",
        "buyCakeLabel"
    ]);
    var t = useTranslation().t;
    var ref = useState(""), userEmail = ref[0], setUserEmail = ref[1];
    var ref1 = useState(""), subscribeError = ref1[0], setSubscribeError = ref1[1];
    var ref2 = useState(false), subscribeSuccess = ref2[0], setSubscribeSuccess = ref2[1];
    var subscribe = function() {
        console.log("Email", userEmail);
        if (userEmail) {
            var ref;
            setSubscribeError("");
            (ref = document.querySelector(".subs-btn > img")) === null || ref === void 0 ? void 0 : ref.classList.add("animated-spin");
            axios.post("".concat(baseURL, "/subscribe/news-letter"), {
                email: userEmail
            })// .post("http://cannabisswap.de/admin/api/subscribe/news-letter", { email: userEmail })
            .then(function(res) {
                console.log(res.data);
                if (res.data.message == "Thank you for subscribing to our newsletter!") {
                    setSubscribeSuccess(true);
                } else {
                    setSubscribeError(res.data.message);
                }
            }).catch(function(err) {
                console.log(err.response);
                if (err.response && err.response.data && err.response.data.message) setSubscribeError(err.response.data.message);
                else setSubscribeError("An error occurred!");
            }).finally(function() {
                var ref;
                (ref = document.querySelector(".subs-btn > img")) === null || ref === void 0 ? void 0 : ref.classList.remove("animated-spin");
            });
        } else {
            setSubscribeError("Please enter your email!");
        }
    };
    return /*#__PURE__*/ _jsx(StyledFooter, _object_spread_props(_object_spread({
        "data-theme": "dark",
        p: [
            "40px 16px",
            null,
            "150px 40px 100px 40px"
        ]
    }, props), {
        justifyContent: "center",
        children: /*#__PURE__*/ _jsxs(Flex, {
            flexDirection: "column",
            width: [
                "100%",
                null,
                "1200px;"
            ],
            children: [
                /*#__PURE__*/ _jsx(StyledIconMobileContainer, {
                    display: [
                        "block",
                        null,
                        "none"
                    ],
                    children: /*#__PURE__*/ _jsxs(Flex, {
                        className: "footer-logo",
                        children: [
                            /*#__PURE__*/ _jsx("img", {
                                className: "header-logo",
                                src: "/logo.png",
                                alt: "logo",
                                style: {
                                    width: "45px",
                                    height: "45px"
                                }
                            }),
                            /*#__PURE__*/ _jsx(LogoText, {
                                children: "Cannabis Swap"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsxs(Flex, {
                    order: [
                        2,
                        null,
                        1
                    ],
                    flexDirection: [
                        "column",
                        null,
                        "row"
                    ],
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    mb: [
                        "42px",
                        null,
                        "36px"
                    ],
                    className: "footerBorder",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "footer-box",
                            children: [
                                /*#__PURE__*/ _jsx("p", {
                                    style: {
                                        lineHeight: "25px"
                                    },
                                    children: t("Don’t miss out, Stay updated Sign up for updates and market news. Subscribe to our newsletter and receive update about ICOs and crypto tips.")
                                }),
                                /*#__PURE__*/ _jsx(FooterHeading, {
                                    style: {
                                        marginBottom: "20px"
                                    },
                                    children: "Newsletter"
                                }),
                                /*#__PURE__*/ _jsx(Flex, {
                                    className: "newsletter-box",
                                    width: "100%",
                                    children: subscribeSuccess ? /*#__PURE__*/ _jsx("p", {
                                        style: {
                                            marginTop: "30px",
                                            marginBottom: "30px",
                                            fontSize: "14px"
                                        },
                                        children: "Thank you for subscribing to our newsletter!"
                                    }) : /*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            /*#__PURE__*/ _jsx(EmailInput, {
                                                type: "text",
                                                name: "user-email",
                                                placeholder: "Enter Your Email",
                                                value: userEmail,
                                                onChange: function(e) {
                                                    return setUserEmail(e.target.value);
                                                }
                                            }),
                                            /*#__PURE__*/ _jsx("button", {
                                                type: "button",
                                                className: "subs-btn",
                                                onClick: subscribe,
                                                children: /*#__PURE__*/ _jsx(ReactSVG, {
                                                    src: SubmitBtn.src,
                                                    width: 50,
                                                    style: {
                                                        cursor: "pointer"
                                                    },
                                                    alt: "Submit"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                subscribeError && /*#__PURE__*/ _jsx("p", {
                                    style: {
                                        color: "red",
                                        marginTop: "8px",
                                        fontSize: "12px"
                                    },
                                    children: subscribeError
                                }),
                                items === null || items === void 0 ? void 0 : items.map(function(item, index) {
                                    return /*#__PURE__*/ _jsx(StyledList, {
                                        children: index == 1 && /*#__PURE__*/ _jsx(SocialLinks, {
                                            order: [
                                                2
                                            ]
                                        })
                                    }, item.label);
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(Flex, {
                            className: "footerCopyrightDesk",
                            flexDirection: "column",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ _jsx("img", {
                                    src: CoinFooter.src,
                                    alt: "coin"
                                }),
                                /*#__PURE__*/ _jsx(Copyright, {
                                    children: "Copyright \xa9 2022"
                                })
                            ]
                        }),
                        items === null || items === void 0 ? void 0 : items.map(function(item, index) {
                            var ref;
                            /*#__PURE__*/ return _jsx(StyledList, {
                                children: (ref = item.items) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                                    var label = param.label, href = param.href, _isHighlighted = param.isHighlighted, isHighlighted = _isHighlighted === void 0 ? false : _isHighlighted;
                                    return /*#__PURE__*/ _jsx(CustomListItem, {
                                        children: href ? /*#__PURE__*/ _jsx(Link, {
                                            href: href,
                                            children: label
                                        }) : /*#__PURE__*/ _jsx(StyledText, {
                                            children: label
                                        })
                                    }, label);
                                })
                            }, item.label);
                        }),
                        /*#__PURE__*/ _jsxs(Flex, {
                            className: "footerCopyrightMbl",
                            flexDirection: "column",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ _jsx("img", {
                                    src: CoinFooter.src,
                                    alt: "coin"
                                }),
                                /*#__PURE__*/ _jsx(Copyright, {
                                    children: "Copyright \xa9 2022"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
};
export default MenuItem;
